export default "<template>\n\n  <KIcon icon=\"Non icon\" />\n\n</template>\n";